import { CircularProgress, Grid, Typography } from "@mui/material";
import DataTable from "react-data-table-component";

const Table = ({ loading, columns, data, title, handleRowClick, ...props }) => {
    return (
        <DataTable
            progressComponent={
                <Grid
                    container
                    direction={"column"}
                    sx={{ m: 3, justifyContent: "center", alignItems: "center" }}
                    spacing={3}
                >
                    <CircularProgress />
                    <Typography variant="h6" sx={{ ml: 2 }}>
                        Getting data...
                    </Typography>
                </Grid>
            }
            progressPending={loading}
            columns={columns}
            data={data}
            title={title}
            keyField="handleId"
            paginationPerPage={10}
            onRowClicked={handleRowClick}
            onChangePage={() => { }}
            paginationRowsPerPageOptions={[10, 15, 20]}
            theme="dark"
            highlightOnHover
            responsive
            pointerOnHover
            pagination
            {...props}
        />
    );
};

export default Table;
